if (!customElements.get('sisway-benefits')) {
  customElements.define('sisway-benefits', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = [...this.querySelectorAll('[data-benefit-item]')];
      this.items.forEach((item) => {
        item.querySelector('button').addEventListener('click', () => this.select(item), options);
      });
      document.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-benefit-item]');
        if (item && this.contains(item)) this.select(item);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
    select(selected) {
      this.items.forEach((item) => {
        const active = item === selected;
        item.querySelector('button').setAttribute('aria-expanded', String(active));
        item.querySelector('.sisway-benefits__details').hidden = !active;
      });
      this.querySelectorAll('[data-benefit-image]').forEach((image) => {
        image.hidden = image.dataset.benefitImage !== selected.dataset.benefitItem;
      });
    }
  });
}
